import {
  GET_RESOURCE,
  LOCK_RESOURCE_BOOKING_TIME_SLOT,
} from "../actions/types";

export default (state = {}, action) => {
  let status = 200;
  let data = {};
  let notificationType = "info";
  if (
    action.payload != undefined &&
    typeof action.payload.status != "undefined"
  ) {
    status = action.payload.status;
    notificationType = "success";
    if (status >= 400) {
      notificationType = "error";
    }
    data = action.payload.data;
  }

  let response = {
    notificationType: notificationType,
    type: action.type,
    status: status,
    action: "LIST",
  };
  switch (action.type) {
    case GET_RESOURCE:
    case LOCK_RESOURCE_BOOKING_TIME_SLOT:
      response["action"] = action.type;
      response["data"] = data;
      break;
    default:
      return state;
  }
  return response;
};
